import { render, staticRenderFns } from "./RegisterIntegratePage.vue?vue&type=template&id=3388b120&scoped=true&"
import script from "./RegisterIntegratePage.vue?vue&type=script&lang=js&"
export * from "./RegisterIntegratePage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterIntegratePage.vue?vue&type=style&index=0&id=3388b120&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388b120",
  null
  
)

export default component.exports